/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GreenMachineStatsActiveSlatesQueryVariables = {||};
export type GreenMachineStatsActiveSlatesQueryResponse = {|
  +activeSlates: ?$ReadOnlyArray<?{|
    +id: string,
    +prettyStartTime: ?string,
    +suffix: ?string,
    +gameType: {|
      +name: string,
      +sport: {|
        +name: string
      |},
    |},
  |}>
|};
export type GreenMachineStatsActiveSlatesQuery = {|
  variables: GreenMachineStatsActiveSlatesQueryVariables,
  response: GreenMachineStatsActiveSlatesQueryResponse,
|};
*/


/*
query GreenMachineStatsActiveSlatesQuery {
  activeSlates {
    id
    prettyStartTime
    suffix
    gameType {
      name
      sport {
        name
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GreenMachineStatsActiveSlatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "activeSlates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeType",
            "kind": "LinkedField",
            "name": "gameType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SportType",
                "kind": "LinkedField",
                "name": "sport",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GreenMachineStatsActiveSlatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "activeSlates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeType",
            "kind": "LinkedField",
            "name": "gameType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SportType",
                "kind": "LinkedField",
                "name": "sport",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "202b637efa2fa532bf9a71e2f1ad547d",
    "id": null,
    "metadata": {},
    "name": "GreenMachineStatsActiveSlatesQuery",
    "operationKind": "query",
    "text": "query GreenMachineStatsActiveSlatesQuery {\n  activeSlates {\n    id\n    prettyStartTime\n    suffix\n    gameType {\n      name\n      sport {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '961c64554415ca0a39ce304002809048';

module.exports = node;
